import React from 'react'
import KitiRechargeContainer from 'containers/panel/admin/kiti-recharge-container'

const KitiRechargePage = () => {
  return (
    <KitiRechargeContainer/>
  )
}

export default KitiRechargePage